import React from 'react';
import { TemplateScopeType, TemplateType } from '@dev/ee-api/ee-api-models';
import { push as Push } from 'redux-first-history';
import { useDispatch, useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { useLocation } from 'react-router';
import { TemplateList as TemplateListModule } from '@dev/ee-modules';

import { FormsPaths } from '@/services/dictionaries/Paths';
import { ShowDialog } from '@/store/dialog/actions';
import { ShowDialogParams } from '@/store/dialog/types';
import {
    getTemplateList,
    StartLoadingTemplateParams,
    StartLoadingTemplates,
} from '@/store/templateList/actions';
import { getConfigStore } from '@/store';
import { getAccountStore } from '@/store/account/actions';
import { GetDashboardSettings, getDashboardSettingsStore } from '@/store/dashboardSettings/actions';
import { ApplicationState } from '@/store';
import { TemplateOpenFromGallery, TemplatePreviewFromGallery } from '@/store/formCreator/actions';
import { sendEventToGTM } from '@dev/ee-tools';

export const GalleryTemplateList = (): JSX.Element => {
    const { t } = useTranslation();
    const location = useLocation();
    const dispatch = useDispatch();

    const config = useSelector(getConfigStore);
    const account = useSelector(getAccountStore);
    const browser = useSelector((state: ApplicationState) => state.browser);
    const templates = useSelector(getTemplateList);
    const dashboardSettings = useSelector(getDashboardSettingsStore);

    const startLoadingTemplates = (params: StartLoadingTemplateParams) =>
        dispatch(
            StartLoadingTemplates({
                ...params,
                type: [TemplateScopeType.Global],
                templateTypes: [TemplateType.FormTemplate],
            })
        );
    const showDialog = (params: ShowDialogParams) => dispatch(ShowDialog(params));
    const push = (url: string) => dispatch(Push(url));

    const previewTemplateFromGallery = () => {
        //mustn't be deleted
    };

    const editTemplateFromGallery = (templateName: string, templateType: TemplateType, isPublic?: boolean) => {
        sendEventToGTM("select-form-template", { templateName })
        dispatch(TemplateOpenFromGallery(templateName, isPublic));
    };

    const templatePreviewStart = (templateName: string, isPublic?: boolean) => {
        
        dispatch(TemplatePreviewFromGallery(templateName, isPublic));
    };

    const galleryScrollContainerId = 'galleryScrollContainer';
    const galleryScrollContainerSelector = `#${galleryScrollContainerId} .MuiDialog-paperScrollBody`;

    return (
        <TemplateListModule
            paths={FormsPaths}
            t={t}
            config={config}
            account={account}
            dashboardSettings={dashboardSettings}
            browser={browser}
            templates={templates}
            location={location}
            GalleryTemplatePreview={previewTemplateFromGallery}
            GalleryTemplateEdit={editTemplateFromGallery}
            StartLoadingTemplates={startLoadingTemplates}
            ShowDialog={showDialog}
            isCampaignCreator
            GetDashboardSettings={GetDashboardSettings}
            Push={push}
            TemplatePreviewStart={templatePreviewStart}
            lazyLoadScrollContainer={galleryScrollContainerSelector}
            isFormsGallery
            APIPATH={APIPATH}
            hideTemplateType
        />
    );
};
